<template>
  <div>
    <base-header
      v-once
      pageName="내 활동 정보"
      :prevBtnShow="true"
      history="main"
    ></base-header>
    <section id="wrap">
      <div class="ep-info">
        <div class="user">
          <figure>
            <img v-if="!setNoImg && userInfo.rpimgp != null && userInfo.rpimgp != 'null'"
              v-bind:src="userInfo.kssImgUrl + userInfo.rpimgp"
              @error="imgDefaultSet"  alt="">
            <img v-else src="@/assets/images/avatar200.png">
          </figure>
          <p><em :class="userInfo.gubun | jicClass"></em> <span>{{userInfo.akdnam}}</span><i>({{userInfo.akdcde}})</i></p>
          <span>{{userInfo.gnrlName}}/{{userInfo.cntrName}}</span>
          <span>{{userInfo.akdid1 | birthDate}}</span>
        </div>
        <p v-if="graphShow && masterShow && orgnzPstn != 'COG01'">
          <span>다음 <b>{{userInfo.need | numFormat}}</b>원 달성 시 <b>위촉 ({{nextTit}}) '매출 기준'</b> 달성입니다.</span>
        </p>
        <p v-if="graphShow && !masterShow && orgnzPstn != 'COG01'">
          <span>다음 <b>{{userInfo.need | numFormat}}</b>원 달성 시 <b>{{nextTit}}</b> 매출 기준 달성입니다.</span>
        </p>
        <!-- EDU 자격코드 변경 건 : 20220915, 배명훈
          <p v-if="!graphShow && orgnzPstn != 'COG01'">
          <span>에듀플래너가 되기 위해서 E-PL 전문가 과정 이수가 필요합니다. </span>
        </p> -->
        <div class="graph" v-if="graphShow && !masterShow && orgnzPstn != 'COG01'">
          <p :class="state"><em></em></p>
          <span>누적 {{ userInfo.siljuck | numFormat}}원</span>
          <i>플래너</i>
          <i>{{nextTit}}</i>
        </div>
        <div class="graph" v-if="graphShow && masterShow && orgnzPstn != 'COG01'">
          <p :class="state"><em></em></p>
          <span>누적 {{ userInfo.siljuck | numFormat}}원</span>
          <i>마스터</i>
          <i>{{nextTit}}</i>
        </div>
        <button type="button" class="profile" @click="showProfile">프로필 상세</button>
      </div>

      <div class="detail-month" v-if="orgnzPstn != 'COG01'">
        <div class="detail-result">
          <h6>{{month}}월 실적 상세</h6>
          <div>
            <div class="month">
              <b>당월 인정 실적</b>
              <em>{{performInfo.perform > 3000000 ?	"실활동" : (performInfo.perform > 0 ? "가동" : "미가동")}}</em>
              <span><i>{{ performInfo.perform | numFormat}}</i> 원</span>
            </div>
            <div class="item">
              <strong>예상 수수료 조회하기</strong>
              <button type="button" class="more" @click="goOtherSite('kss','/hdof/cmmsExpcInq')">자세히보기</button>
              <!-- 2022-09-22 : 예상 수수료값 노출 안함, kss에서 확인
              <ul>
                <li>㈜교원에듀 : {{ performInfo.totCmms | numFormat}}원</li>
              </ul> -->
            </div>
          </div>
        </div>
        <div class="detail-activity" v-if="orgnzPstn != 'COG01'">
          <h6>{{month}}월 활동 상세</h6>
          <div>
            <ul>
              <li>아침 미팅</li>
              <li>{{activityInfo.meetCnt}}일</li>
              <li>소스등록</li>
              <li>{{activityInfo.custmCnt}}건</li>
              <li>홈클래스</li>
              <li>{{activityInfo.homeclassCnt}}건</li>
              <!-- <li>리크루팅</li>
              <li>{{activityInfo.recruitCnt}}건</li> -->
            </ul>
            <div>
              <strong>상담</strong>
              <span><b>{{activityInfo.cnslCnt}}</b>건</span>
              <dl>
                <dt>상품</dt>
                <dd>{{activityInfo.planCnt}}건</dd>
                <dt>리크루팅</dt>
                <dd>{{activityInfo.schRcrtCnt}}건</dd>
                <dt>진단검사</dt>
                <dd>{{activityInfo.schTestCnt}}건</dd>
              </dl>
            </div>
            <div>
              <strong>진단검사</strong>
              <span><b>{{activityInfo.dgnstCnt}}</b>건</span>
              <dl>
                <dt>KED-I</dt>
                <dd>{{activityInfo.kedICnt}}건</dd>
                <dt>KED-S</dt>
                <dd>{{activityInfo.kedSCnt}}건</dd>
                <dt>AI ELT</dt>
                <dd>{{activityInfo.aiEltCnt}}건</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>

      <div class="my-studyInfo" v-if="orgnzPstn != 'COG01'">
        <div>
          <h4>필수 교육과정</h4>
          <ul>
            <li class="head">
              <strong>교육과정</strong>
              <strong>수료</strong>
            </li>
            <li v-for="(item,index) in eduInfo" :key="index">
              <span>{{item.lecNm}}</span>
              <i class="yes"></i>
            </li>
          </ul>
        </div>
      </div>
      <!-- 2026.09.18 챗봇 버튼-->
      <div class="fltMn">
          <button type="button" class="chatbot allow-click" @click="chatbot"></button>
      </div>
      <!--// 2026.09.18 챗봇 버튼-->
    </section>
  </div>
  </template>

  <script>
  export default {
    name: "OrgnzDetail",
    components: {
    },
    data() {
      return{
        orgnzPstn: this.$store.getters.orgnzPstn,
        month: new Date().getMonth()+1,
        graphShow:false,
        masterShow:false,
        jiGooShow:false,
        nextTit:'',
        state:'Lv1',
        loginGbn : this.$store.getters.loginGbn, //로그인구분
        userInfo:{
          akdcde : "",
          gubun : this.$store.getters.orgnzPstn,
          akdnam : ""
        },
        performInfo:{
          perform : 0
        },
        activityInfo:{},
        eduInfo:[],
        setNoImg: false,
      };
    },
    methods: {
      showProfile:function(){
        var param = "?targetId="+this.userInfo.akdcde;
        param += "&akdnam="+this.userInfo.akdnam;
        param += "&gubun="+this.userInfo.gubun;
        this.$utils.nativeIf.outbound.newPage("/orgStatus/orgStatusView/profileDetails"+param);
      },
      // Studit(교육과정) 연동 삭제 건으로 kss(예상 수수료) 링크만 남김 - 2026-09-16
      goOtherSite:function(type, url){
        if(type == 'kss'){
          var that = this;
          this.$api.dashboard
          .getSsoToken()
          .then(function (data) {
            // console.log("GET TOKEN.",data)
            if(data && data.token && data.userIdEnc){
              var ssoUrl = 'http://ksos.kyowon.co.kr?';
              ssoUrl += 'userId='+data.userIdEnc+'&token='+data.token;
              if(url)
                ssoUrl += '&path='+url;

              that.$utils.nativeIf.outbound.outlink(ssoUrl)
            }else{
              // alert("SSO연동에 실패 하였습니다.")
              that.$utils.nativeIf.outbound.outlink("https://ksos.kyowon.co.kr"+url);
            }
          })
          .catch(function (error) {
            alert(error.rtMsg);
          });
        }
      },
      imgDefaultSet(){
        this.setNoImg = true;
      },
      chatbot: function(){
          this.$api.chatbot
          .getChatbotToken()
          .then((token) => {
            this.token = token;
            if(this.token != null){
                // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
                window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
            }else {
                console.log("else token");
            }
          })
          .catch(function (error) {
            alert(error.rtMsg);
          });
      },
    },
    created: function() {
      // var paramGubun = this.orgnzPstn;
      // if(paramGubun != "COG06"){	 //E-PA 일때 그래프 노출 안함.
      //   this.graphShow = true;
      // }
      // if(paramGubun == "COG02"){
      //   this.jiGooShow = true;
      // }
      // if(paramGubun == "COGA2"){
      //   this.masterShow = true;
      // }

      var that = this
      var parameters = {
        'targetId': "userId"
      };

      this.$api.orgnz
      .detail(parameters)
      .then(function(data) {
        var userInfo = data;
        var siljuck = userInfo.siljuck;

        // if(userInfo.gubun != "COG06"){	 //E-PA 일때 그래프 노출 안함.
        //   that.graphShow = true;
        // }

        if(userInfo.gubun == "COG02"){
          that.jiGooShow = true;

          that.nextTit = "지국장";
          if(siljuck > 50000000){	 //지국장달성
            userInfo.need = 0
            that.state='Lv5';
          }else{
            userInfo.need = 50000000 - siljuck
            that.state='Lv3';
            if(siljuck < 1){
              that.state='Lv1';
            }
          }
        }else if(userInfo.gubun == "COGA2"){
          that.masterShow = true;

          that.nextTit = "지국장";
          if(siljuck > 100000000){	 //지국장달성
            userInfo.need = 0
            that.state='Lv5';
          }else{
            userInfo.need = 100000000 - siljuck
            that.state='Lv3';
            if(siljuck < 1){
              that.state='Lv1';
            }
          }
        }else if(that.orgnzPstn != 'COG01'){
          if(siljuck >= 50000000){	 //지국장달성
            userInfo.need = 0
            that.nextTit = "마스터";
            that.state='Lv5';
          }else if(siljuck > 25000000){ //프로달성
            userInfo.need = 50000000 - siljuck
            that.nextTit = "마스터";
            that.state='Lv3';
          }else if(siljuck > 0){ //일반
            userInfo.need = 50000000 - siljuck
            that.nextTit = "마스터";
            that.state='Lv2';
          }else{
            userInfo.need = 50000000;
            that.nextTit = "마스터";
            that.state='Lv1';
          }
        }
        that.userInfo = userInfo;

        if(that.orgnzPstn != 'COG01'){
          parameters.gubun = userInfo.gubun;

          that.$api.orgnz
          .perform(parameters)
          .then(function(data) {
            if(data)
              that.performInfo = data;
          })
          .catch(function(error) {
            alert(error.rtMsg);
          });
        }
      })
      .catch(function(error) {
        alert(error.rtMsg);
      });

      if(this.orgnzPstn != 'COG01'){
        this.$api.orgnz
        .activity(parameters)
        .then(function(data) {
          if(data.activityInfo){
            var activityInfo = data.activityInfo;
            activityInfo.dgnstCnt = activityInfo.kedICnt + activityInfo.kedSCnt + activityInfo.aiEltCnt;
            activityInfo.cnslCnt = activityInfo.planCnt + activityInfo.schRcrtCnt + activityInfo.schTestCnt;
            that.activityInfo = activityInfo;
          }

          if(data.eduInfo)
            that.eduInfo = data.eduInfo;
        })
        .catch(function(error) {
          alert(error.rtMsg);
        });
      }
    },
    filters:{
      numFormat:function(num){
        if(!num || num==0) return 0;

        var n = num+'';
        var reg = /(^[+-]?\d+)(\d{3})/;

        while (reg.test(n))
          n = n.replace(reg,'$1'+','+'$2');

        return n;
      },
      birthDate:function(date){
        if(!date) return date;

        var birthDay = date;
        if(date.length == 8){
          birthDay = date.substring(0,4) + ".";
          birthDay += date.substring(4,6) + ".";
          birthDay += date.substring(6,8);
        }else if(date.length == 6){
          if(date.substring(0,2) < 50){
            birthDay =20;
          }else{
            birthDay =19;
          }
          birthDay += date.substring(0,2) + ".";
          birthDay += date.substring(2,4) + ".";
          birthDay += date.substring(4,6);
        }

        return birthDay;
      },
      jicClass:function(gubun){
        if(gubun == 'COG01'){
          return "epLv";
        }else if(gubun == 'COG02'){
          return "epLv1";
        }else if(gubun == 'COGA2'){
          return "epLvA1";
        }else if(gubun == 'COG03'){
          return "epLv2";
        }else if(gubun == 'COG04'){
          return "epLv3";
        }else if(gubun == 'COG05'){
          return "epLv4";
        }else if(gubun == 'COG06'){
          return "epLv5";
        }
      }
    }
  };
  </script>
